<template>
  <div class="nova-senha">
    <h2>NOVA SENHA</h2>
    <form method="post" action="javascript:void(0)" @submit.prevent="novaSenha" data-testid="form-nova-senha">
      <div class="form-group">
        <div class="input-group password-input-wrapper">
          <input 
            :type="showPassword ? 'text' : 'password'" 
            id="password" 
            v-model="password" 
            required
            data-testid="password-input"
            @input="validatePassword"
          />
          <label class="control-label" for="password">Nova senha</label>
          <i class="bar"></i>
          <button 
            type="button" 
            class="toggle-password" 
            @click="showPassword = !showPassword"
            tabindex="-1"
            data-testid="toggle-password-visibility"
          >
            <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
        </div>
        <small v-if="passwordError" class="error-message" data-testid="password-error-message">{{ passwordError }}</small>
      </div>
      
      <div class="form-group">
        <div class="input-group password-input-wrapper">
          <input 
            :type="showRepeatPassword ? 'text' : 'password'" 
            id="repeat_password" 
            v-model="repeatPassword" 
            required
            data-testid="repeat-password-input"
            @input="validateRepeatPassword"
          />
          <label class="control-label" for="repeat_password">Repetir senha</label>
          <i class="bar"></i>
          <button 
            type="button" 
            class="toggle-password" 
            @click="showRepeatPassword = !showRepeatPassword"
            tabindex="-1"
            data-testid="toggle-repeat-password-visibility"
          >
            <i :class="showRepeatPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
          </button>
        </div>
        <small v-if="repeatPasswordError" class="error-message" data-testid="repeat-password-error-message">{{ repeatPasswordError }}</small>
      </div>
      
      <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between down-container">
        <button 
          class="btn btn-primary btn-block" 
          type="submit" 
          data-testid="redefinir-button"
          :disabled="loading || !isFormValid"
        >
          {{ loading ? 'AGUARDE...' : 'REDEFINIR' }}
        </button>
      </div>
      
      <div class="d-flex flex-column text-center">
        <router-link class='link btn-link' :to="{name: 'login'}" data-testid="voltar-login-link">
          Já tenho uma conta
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'nova-senha',
  data() {
    return {
      token: this.$route.params.token,
      password: '',
      repeatPassword: '',
      showPassword: false,
      showRepeatPassword: false,
      passwordError: '',
      repeatPasswordError: '',
      loading: false,
    }
  },
  computed: {
    isFormValid() {
      return (
        this.password.length >= 8 &&
        this.password === this.repeatPassword &&
        !this.passwordError &&
        !this.repeatPasswordError
      )
    }
  },
  methods: {
    validatePassword() {
      if (this.password.length === 0) {
        this.passwordError = ''
      } else if (this.password.length < 8) {
        this.passwordError = 'A senha deve ter no mínimo 8 caracteres'
      } else {
        this.passwordError = ''
      }
      
      // Revalida a confirmação se já foi preenchida
      if (this.repeatPassword.length > 0) {
        this.validateRepeatPassword()
      }
    },
    
    validateRepeatPassword() {
      if (this.repeatPassword.length === 0) {
        this.repeatPasswordError = ''
      } else if (this.repeatPassword !== this.password) {
        this.repeatPasswordError = 'As senhas não coincidem'
      } else {
        this.repeatPasswordError = ''
      }
    },
    
    async novaSenha() {
      // Validação final antes de enviar
      this.validatePassword()
      this.validateRepeatPassword()
      
      if (!this.isFormValid) {
        if (this.password.length < 8) {
          Vue.toasted.show('A senha deve ter no mínimo 8 caracteres', {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
          })
        } else if (this.password !== this.repeatPassword) {
          Vue.toasted.show('As senhas não coincidem', {
            icon: 'fa-times',
            position: 'top-right',
            duration: 5000,
          })
        }
        return
      }
      
      this.loading = true
      
      try {
        const response = await this.$http.patch(
          `${process.env.VUE_APP_URL_API}/login/reset-password`,
          {
            token: this.token,
            password: this.password,
            repeat_password: this.repeatPassword
          }
        )
        
        Vue.toasted.show(response.body.mensagem || 'Senha alterada com sucesso!', {
          icon: 'fa-check',
          position: 'top-right',
          duration: 5000,
          type: 'success'
        })
        
        // Aguarda 2 segundos e redireciona para login
        setTimeout(() => {
          this.$router.push({ name: 'login' })
        }, 2000)
        
      } catch (error) {
        console.error('Erro ao redefinir senha:', error)
        
        let mensagem = 'Não foi possível alterar sua senha. Por favor, tente novamente.'
        
        if (error.status === 422 && error.body && error.body.errors) {
          const errors = Object.values(error.body.errors).flat()
          mensagem = errors.join(', ')
        } else if (error.body && error.body.mensagem) {
          mensagem = error.body.mensagem
        }
        
        Vue.toasted.show(mensagem, {
          icon: 'fa-times',
          position: 'top-right',
          duration: 5000,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-link {
    margin-top: 25px;
  }
  
  .nova-senha {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
      margin-bottom: 2rem;
      color: #333;
    }
    
    width: 22.375rem;

    .down-container {
      margin-top: 2.6875rem;
    }
    
    .password-input-wrapper {
      position: relative;
      
      .toggle-password {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        background: none;
        border: none;
        cursor: pointer;
        color: #666;
        font-size: 1.2rem;
        padding: 5px 10px;
        z-index: 10;
        transition: color 0.3s;
        
        &:hover {
          color: #333;
        }
        
        &:focus {
          outline: none;
        }
      }
      
      input {
        padding-right: 45px;
      }
    }
    
    .error-message {
      display: block;
      color: #d32f2f;
      font-size: 0.875rem;
      margin-top: 0.5rem;
      margin-left: 0.25rem;
    }
    
    .btn-primary {
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
</style>
